<template>
    <div id="generic_price_table" style="margin-top: 3%;">
        <section>
            <div class="container">
                <div class="row">
                    <div class="col-md-3">
                        <div class="generic_content clearfix">

                            <!--HEAD PRICE DETAIL START-->
                            <div class="generic_head_price clearfix" style=" height: 150px;">

                                <!--HEAD CONTENT START-->
                                <div class="generic_head_content clearfix">

                                    <!--HEAD START-->
                                    <div class="head_bg"></div>
                                    <div class="head">
                                        <span>Lo más visto</span>
                                    </div>
                                    <!--//HEAD END-->

                                </div>


                            </div>

                            <div class="row mt-3">
                                <div id="carouselLoMasVisto" class="carousel carousel-dark slide carousel-fade"
                                    data-bs-ride="carousel">
                                    <div class="carousel-inner">
                                        <div v-for="(item, index) in losmasvistosprods" class="carousel-item"
                                            :class="{ active: index === 0 }" :key="'slider-' + index"
                                            data-bs-interval="1500">
                                            <router-link :to="{ name: 'verprods', params: { id: item.k_parte } }"
                                                style="text-decoration: none; color: inherit; cursor: pointer;">
                                                <div class="card mx-auto"
                                                    style="max-width: 13rem; margin-bottom: 10px; border: none; min-height: 300px; max-height: 550px">
                                                    <img :src="getSafeImage(item)" class="card-img-top"
                                                        :alt="item.k_parte"
                                                        style="max-width: 100%; max-height: 200px; object-fit: cover; border-radius: 8px; width: 200px; height: 200px;" />
                                                    <div class="card-body">
                                                        <div class="badge-container text-center"
                                                            style="height: 30px; display: flex; justify-content: center; align-items: center;">
                                                            <span class="badge rounded-pill mx-1"
                                                                style="background-color: #800020;" v-if="item.especial">
                                                                <i class="bx bx-crown" aria-hidden="true"></i>
                                                                Recomendación
                                                                para ti
                                                            </span>
                                                            <span class="badge rounded-pill mx-1"
                                                                style="background-color: #FFBD07;"
                                                                v-if="item.mejoresventas">
                                                                <i class="bx bx-award" aria-hidden="true"></i> Top
                                                                Ventas
                                                            </span>
                                                            <span class="badge rounded-pill mx-1"
                                                                style="background-color: #043c53;"
                                                                v-else-if="item.mejoresventaslineas">
                                                                <i class="bx bx-star" aria-hidden="true"></i> Top Ventas
                                                                Lineas
                                                            </span>
                                                        </div>
                                                        <div class="card-title-container"
                                                            style="flex-grow: 0;height: 20px;">
                                                            <h5 class="card-title"
                                                                style="color:#ff9900; font-size: 16px; margin: 0; padding: 0;">
                                                                {{ item.k_parte }}</h5>
                                                        </div>

                                                        <div class="card-text-container"
                                                            style="flex-grow: 1; overflow: hidden; display: flex; flex-direction: column;">
                                                            <div class="linea-container" style="height: 40px;">
                                                                <p class="card-text" v-if="item.linea"
                                                                    style="font-size: 14px; margin: 0; padding: 0;">{{
                                                                        item.linea }}</p>
                                                            </div>
                                                            <div class="descripcion-container" style="height: 100px;">
                                                                <p class="card-text" v-if="item.descripcion"
                                                                    style="font-size: 14px; margin: 0; padding: 0;">{{
                                                                        item.descripcion }}</p>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                            </router-link>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="col-md-3">
                        <div class="generic_content clearfix">

                            <!--HEAD PRICE DETAIL START-->
                            <div class="generic_head_price clearfix" style=" height: 150px;">

                                <!--HEAD CONTENT START-->
                                <div class="generic_head_content clearfix">

                                    <!--HEAD START-->
                                    <div class="head_bg"></div>
                                    <div class="head">
                                        <span>Lo más buscado</span>
                                    </div>
                                    <!--//HEAD END-->

                                </div>
                            </div>
                            <div class="row mt-3">
                                <div id="carouselLoMasbuscados" class="carousel carousel-dark slide carousel-fade"
                                    data-bs-ride="carousel">
                                    <div class="carousel-inner">
                                        <div v-for="(item, index) in masbuscados" class="carousel-item"
                                            :class="{ active: index === 0 }" :key="'slidermasbuscados-' + index"
                                            data-bs-interval="1500">
                                            <router-link :to="{ name: 'verprods', params: { id: item.k_parte } }"
                                                style="text-decoration: none; color: inherit; cursor: pointer;">
                                                <div class="card mx-auto"
                                                    style="max-width: 13rem; margin-bottom: 10px; border: none; min-height: 300px; max-height: 550px">
                                                    <!-- Imagen -->
                                                    <img :src="getSafeImage(item)" class="card-img-top"
                                                        :alt="item.k_parte"
                                                        style="max-width: 100%; max-height: 200px; object-fit: cover; border-radius: 8px; width: 200px; height: 200px;" />

                                                    <!-- Cuerpo de la tarjeta -->
                                                    <div class="card-body">
                                                        <div class="badge-container text-center"
                                                            style="height: 30px; display: flex; justify-content: center; align-items: center;">
                                                            <span class="badge rounded-pill mx-1"
                                                                style="background-color: #800020;" v-if="item.especial">
                                                                <i class="bx bx-crown" aria-hidden="true"></i>
                                                                Recomendación
                                                                para ti
                                                            </span>
                                                            <span class="badge rounded-pill mx-1"
                                                                style="background-color: #FFBD07;"
                                                                v-if="item.mejoresventas">
                                                                <i class="bx bx-award" aria-hidden="true"></i> Top
                                                                Ventas
                                                            </span>
                                                            <span class="badge rounded-pill mx-1"
                                                                style="background-color: #043c53;"
                                                                v-else-if="item.mejoresventaslineas">
                                                                <i class="bx bx-star" aria-hidden="true"></i> Top Ventas
                                                                Lineas
                                                            </span>
                                                        </div>
                                                        <div class="card-title-container"
                                                            style="flex-grow: 0;height: 20px;">
                                                            <h5 class="card-title"
                                                                style="color:#ff9900; font-size: 16px; margin: 0; padding: 0;">
                                                                {{ item.k_parte }}</h5>
                                                        </div>

                                                        <div class="card-text-container"
                                                            style="flex-grow: 1; overflow: hidden; display: flex; flex-direction: column;">
                                                            <div class="linea-container" style="height: 40px;">
                                                                <p class="card-text" v-if="item.linea"
                                                                    style="font-size: 14px; margin: 0; padding: 0;">{{
                                                                        item.linea }}</p>
                                                            </div>
                                                            <div class="descripcion-container" style="height: 100px;">
                                                                <p class="card-text" v-if="item.descripcion"
                                                                    style="font-size: 14px; margin: 0; padding: 0;">{{
                                                                        item.descripcion }}</p>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                            </router-link>
                                        </div>

                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="col-md-3">
                        <div class="generic_content clearfix">

                            <!--HEAD PRICE DETAIL START-->
                            <div class="generic_head_price clearfix" style=" height: 150px;">

                                <!--HEAD CONTENT START-->
                                <div class="generic_head_content clearfix">

                                    <!--HEAD START-->
                                    <div class="head_bg"></div>
                                    <div class="head">
                                        <span>Últimos Vendidos</span>
                                    </div>
                                    <!--//HEAD END-->

                                </div>
                            </div>
                            <div class="row">
                                <div id="carouselprodsultmasvend" class="carousel carousel-dark slide carousel-fade"
                                    data-bs-ride="carousel">
                                    <div class="carousel-inner">
                                        <div v-for="(item, index) in prodsultmasvend" class="carousel-item"
                                            :class="{ active: index === 0 }" :key="'sliderprodsultmasvend-' + index"
                                            data-bs-interval="1500">
                                            <router-link :to="{ name: 'verprods', params: { id: item.k_parte } }"
                                                style="text-decoration: none; color: inherit; cursor: pointer;">
                                                <div class="card mx-auto"
                                                    style="max-width: 13rem; margin-bottom: 10px; border: none; min-height: 300px; max-height: 550px">
                                                    <!-- Imagen -->
                                                    <img :src="getSafeImage(item)" class="card-img-top"
                                                        :alt="item.k_parte"
                                                        style="max-width: 100%; max-height: 200px; object-fit: cover; border-radius: 8px; width: 200px; height: 200px;" />

                                                    <!-- Cuerpo de la tarjeta -->
                                                    <div class="card-body">
                                                        <div class="badge-container text-center"
                                                            style="height: 30px; display: flex; justify-content: center; align-items: center;">
                                                            <span class="badge rounded-pill mx-1"
                                                                style="background-color: #800020;" v-if="item.especial">
                                                                <i class="bx bx-crown" aria-hidden="true"></i>
                                                                Recomendación
                                                                para ti
                                                            </span>
                                                            <span class="badge rounded-pill mx-1"
                                                                style="background-color: #FFBD07;"
                                                                v-if="item.mejoresventas">
                                                                <i class="bx bx-award" aria-hidden="true"></i> Top
                                                                Ventas
                                                            </span>
                                                            <span class="badge rounded-pill mx-1"
                                                                style="background-color: #043c53;"
                                                                v-else-if="item.mejoresventaslineas">
                                                                <i class="bx bx-star" aria-hidden="true"></i> Top Ventas
                                                                Lineas
                                                            </span>
                                                        </div>
                                                        <div class="card-title-container"
                                                            style="flex-grow: 0;height: 20px;">
                                                            <h5 class="card-title"
                                                                style="color:#ff9900; font-size: 16px; margin: 0; padding: 0;">
                                                                {{ item.k_parte }}</h5>
                                                        </div>

                                                        <div class="card-text-container"
                                                            style="flex-grow: 1; overflow: hidden; display: flex; flex-direction: column;">
                                                            <div class="linea-container" style="height: 40px;">
                                                                <p class="card-text" v-if="item.linea"
                                                                    style="font-size: 14px; margin: 0; padding: 0;">{{
                                                                        item.linea }}</p>
                                                            </div>
                                                            <div class="descripcion-container" style="height: 100px;">
                                                                <p class="card-text" v-if="item.descripcion"
                                                                    style="font-size: 14px; margin: 0; padding: 0;">{{
                                                                        item.descripcion }}</p>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                            </router-link>
                                        </div>

                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="col-md-3">
                        <div class="generic_content clearfix">

                            <!--HEAD PRICE DETAIL START-->
                            <div class="generic_head_price clearfix" style=" height: 150px;">

                                <!--HEAD CONTENT START-->
                                <div class="generic_head_content clearfix">

                                    <!--HEAD START-->
                                    <div class="head_bg"></div>
                                    <div class="head">
                                        <span>Más Vendido Hoy</span>
                                    </div>
                                    <!--//HEAD END-->

                                </div>
                            </div>
                            <div class="row">
                                <div id="carouselprodsultmasvend" class="carousel carousel-dark slide carousel-fade"
                                    data-bs-ride="carousel">
                                    <div class="carousel-inner">
                                        <div v-for="(item, index) in prodsultmasvendhoy" class="carousel-item"
                                            :class="{ active: index === 0 }" :key="'sliderprodsultmasvend-' + index"
                                            data-bs-interval="1500">
                                            <router-link :to="{ name: 'verprods', params: { id: item.k_parte } }"
                                                style="text-decoration: none; color: inherit; cursor: pointer;">
                                                <div class="card mx-auto"
                                                    style="max-width: 13rem; margin-bottom: 10px; border: none; min-height: 300px; max-height: 550px">
                                                    <!-- Imagen -->
                                                    <img :src="getSafeImage(item)" class="card-img-top"
                                                        :alt="item.k_parte"
                                                        style="max-width: 100%; max-height: 200px; object-fit: cover; border-radius: 8px; width: 200px; height: 200px;" />

                                                    <!-- Cuerpo de la tarjeta -->
                                                    <div class="card-body">
                                                        <div class="badge-container text-center"
                                                            style="height: 30px; display: flex; justify-content: center; align-items: center;">
                                                            <span class="badge rounded-pill mx-1"
                                                                style="background-color: #800020;" v-if="item.especial">
                                                                <i class="bx bx-crown" aria-hidden="true"></i>
                                                                Recomendación
                                                                para ti
                                                            </span>
                                                            <span class="badge rounded-pill mx-1"
                                                                style="background-color: #FFBD07;"
                                                                v-if="item.mejoresventas">
                                                                <i class="bx bx-award" aria-hidden="true"></i> Top
                                                                Ventas
                                                            </span>
                                                            <span class="badge rounded-pill mx-1"
                                                                style="background-color: #043c53;"
                                                                v-else-if="item.mejoresventaslineas">
                                                                <i class="bx bx-star" aria-hidden="true"></i> Top Ventas
                                                                Lineas
                                                            </span>
                                                        </div>
                                                        <div class="card-title-container"
                                                            style="flex-grow: 0;height: 20px;">
                                                            <h5 class="card-title"
                                                                style="color:#ff9900; font-size: 16px; margin: 0; padding: 0;">
                                                                {{ item.k_parte }}</h5>
                                                        </div>

                                                        <div class="card-text-container"
                                                            style="flex-grow: 1; overflow: hidden; display: flex; flex-direction: column;">
                                                            <div class="linea-container" style="height: 40px;">
                                                                <p class="card-text" v-if="item.linea"
                                                                    style="font-size: 14px; margin: 0; padding: 0;">{{
                                                                        item.linea }}</p>
                                                            </div>
                                                            <div class="descripcion-container" style="height: 100px;">
                                                                <p class="card-text" v-if="item.descripcion"
                                                                    style="font-size: 14px; margin: 0; padding: 0;">{{
                                                                        item.descripcion }}</p>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                            </router-link>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </section>
    </div>
</template>
<script>


export default {
    name: 'TemplateWithColumns',

    data() {
        return {
            losmasvistosprods: [],
            masbuscados: [],
            prodsultmasvend: [],
            prodsultmasvendhoy: [],
            observer: null, // Para el lazy loading
            productCardRef: null, // Referencia para el producto
        };
    },
    methods: {
        getSafeImage(item) {
            const index = item?.categorias?.[0]?.marcas?.viewimagesprinc ?? 4;
            const imageObj = item?.PicturesUrl?.[index];
            return imageObj?.sm || this.getImagePath('img/display/Placeholder.png');
        },
        getInterval(index) {
            // Puedes ajustar la lógica para decidir el intervalo según el índice
            if (index === 0) {
                return 3000; // Primer slide con intervalo más largo
            } else if (index === this.losmasvistosprods.length - 1) {
                return 5000; // Último slide con intervalo más largo
            } else {
                return 2000; // Intervalo más corto para los demás
            }
        },
        getImagePath(relativePath) {
            return `${window.location.origin}/${relativePath}`;
        },

        async fetchData() {
            try {
                /*const [vistos, buscados, vendidos, vendidosHoy] = await Promise.all([
                    axios.get('/homedestacados/vistas'),
                    axios.get('/homedestacados/masbuscados'),
                    axios.get('/homedestacados/prodsultmasvend'),
                    axios.get('/homedestacados/prodsultmasvendhoy')
                ]);*/
                const response = await axios.get('/homedestacados/vistas');
                //console.log(response)
                this.losmasvistosprods = Object.values(response.data);
                //this.masbuscados = buscados.data;
                //this.prodsultmasvend = vendidos.data;
                //this.prodsultmasvendhoy = vendidosHoy.data;
            } catch (error) {
                console.error('Error fetching data:', error);
            }
        },
        async fetchDataMasbuscados() {
            try {
                /*const [vistos, buscados, vendidos, vendidosHoy] = await Promise.all([
                    axios.get('/homedestacados/vistas'),
                    axios.get('/homedestacados/masbuscados'),
                    axios.get('/homedestacados/prodsultmasvend'),
                    axios.get('/homedestacados/prodsultmasvendhoy')
                ]);*/
                const response = await axios.get('/homedestacados/masbuscados');
                //console.log(response)
                //this.losmasvistosprods = Object.values(response.data);
                this.masbuscados = Object.values(response.data);
                //this.prodsultmasvend = vendidos.data;
                //this.prodsultmasvendhoy = vendidosHoy.data;
            } catch (error) {
                console.error('Error fetching data:', error);
            }
        },
        async fetchDataProdsultmasvends() {
            try {
                /*const [vistos, buscados, vendidos, vendidosHoy] = await Promise.all([
                    axios.get('/homedestacados/vistas'),
                    axios.get('/homedestacados/masbuscados'),
                    axios.get('/homedestacados/prodsultmasvend'),
                    axios.get('/homedestacados/prodsultmasvendhoy')
                ]);*/
                const response = await axios.get('/homedestacados/prodsultmasvend');
                //console.log(response)
                //this.losmasvistosprods = Object.values(response.data);
                this.prodsultmasvend = Object.values(response.data);
                //this.prodsultmasvend = vendidos.data;
                //this.prodsultmasvendhoy = vendidosHoy.data;
            } catch (error) {
                console.error('Error fetching data:', error);
            }
        },
        async fetchDataProdsultmasvendhoy() {
            try {
                /*const [vistos, buscados, vendidos, vendidosHoy] = await Promise.all([
                    axios.get('/homedestacados/vistas'),
                    axios.get('/homedestacados/masbuscados'),
                    axios.get('/homedestacados/prodsultmasvend'),
                    axios.get('/homedestacados/prodsultmasvendhoy')
                ]);*/
                const response = await axios.get('/homedestacados/prodsultmasvendhoy');
                //console.log(response)
                //this.losmasvistosprods = Object.values(response.data);
                this.prodsultmasvendhoy = Object.values(response.data);
                //this.prodsultmasvend = vendidos.data;
                //this.prodsultmasvendhoy = vendidosHoy.data;
            } catch (error) {
                console.error('Error fetching data:', error);
            }
        },
        observeSection() {
            this.observer = new IntersectionObserver((entries) => {
                entries.forEach((entry) => {
                    if (entry.isIntersecting) {
                        this.fetchData();
                        this.observer.disconnect();
                    }
                });
            });
            this.observer.observe(this.$refs.lazyLoadSection);
        },

        flipCard() {
            this.productCardRef.classList.add('flip180');
        },

        flipCardBack() {
            this.productCardRef.classList.remove('flip180');
        },
        getImageSource(item) {
            if (!item.PicturesUrl || Object.keys(item.PicturesUrl).length === 0) {
                return ''; // Evita errores si PicturesUrl no tiene valores
            }

            const index = item.categorias[0].marcas.viewimagesprinc
                ? item.categorias[0].marcas.viewimagesprinc
                : 1;

            const picturesArray = Object.values(item.PicturesUrl); // Convertimos el objeto en array si es necesario

            if (picturesArray[index] && picturesArray[index].stdClass && picturesArray[index].stdClass.sm) {
                return picturesArray[index].stdClass.sm;
            }

            return ''; // Devuelve una cadena vacía si no hay imagen disponible
        }
    },
    mounted() {
        this.fetchData()
        this.fetchDataMasbuscados()
        this.fetchDataProdsultmasvends()
        this.fetchDataProdsultmasvendhoy()
        // Asigna la referencia del elemento en mounted
        //this.productCardRef = this.$refs.productCard;
    },
    computed: {
        proBusOClient() {
            return this.$store.getters.proBusOClient;
        }
    },
    beforeDestroy() {
        if (this.observer) {
            this.observer.disconnect();
        }
        this.losmasvistosprods = [];
        this.masbuscados = [];
        this.prodsultmasvend = [];
        this.prodsultmasvendhoy = [];
    }
};


</script>
<style scoped>
#generic_price_table {
    background-color: #f0eded;
}

/*PRICE COLOR CODE START*/
#generic_price_table .generic_content {
    background-color: #fff;
}

#generic_price_table .generic_content .generic_head_price {
    background-color: #f6f6f6;
}

.generic_head_content .head_bg {

    /* Asegura que todos tengan esta altura */
    overflow: hidden;
    /* Oculta cualquier contenido que exceda la altura */
}

#generic_price_table .generic_content .generic_head_price .generic_head_content .head_bg {
    border-color: #e4e4e4 rgba(0, 0, 0, 0) rgba(0, 0, 0, 0) #e4e4e4;
    min-height: 130px;
}

#generic_price_table .generic_content .generic_head_price .generic_head_content .head span {
    color: #f6f6f6;
}


#generic_price_table .generic_content .generic_head_price .generic_head_content .head_bg,
#generic_price_table .generic_content .generic_head_price .generic_head_content .head_bg {
    border-color: #ff9900 rgba(0, 0, 0, 0) rgba(0, 0, 0, 0) #ff9900;
    color: #fff;
}

#generic_price_table .generic_content.active .generic_head_price .generic_head_content .head_bg,
#generic_price_table .generic_content:hover .generic_head_price .generic_head_content .head_bg {
    border-color: #ff9900 rgba(0, 0, 0, 0) rgba(0, 0, 0, 0) #cc7a00;
    color: #06283c;
}

#generic_price_table .generic_content:hover .generic_head_price .generic_head_content .head span,
#generic_price_table .generic_content.active .generic_head_price .generic_head_content .head span {
    color: #fff;
}


#generic_price_table {
    margin: 50px 0 50px 0;
    font-family: 'Raleway', sans-serif;
}

.row .table {
    padding: 28px 0;
}

/*PRICE BODY CODE START*/

#generic_price_table .generic_content {
    overflow: hidden;
    position: relative;
    text-align: center;
}

#generic_price_table .generic_content .generic_head_price {
    margin: 0 0 20px 0;
}

#generic_price_table .generic_content .generic_head_price .generic_head_content {
    margin: 0;
    /* Elimina cualquier margen que pueda estar causando el desajuste */
    padding: 0;
    /* Asegúrate de que el padding sea consistente */
}

#generic_price_table .generic_content .generic_head_price .generic_head_content .head_bg {
    border-style: solid;
    border-width: 90px 1011px 23px 399px;
    position: absolute;
}

#generic_price_table .generic_content .generic_head_price .generic_head_content .head {
    padding-top: 40px;
    position: relative;
    z-index: 1;
}

#generic_price_table .generic_content .generic_head_price .generic_head_content .head span {
    font-family: "Raleway", sans-serif;
    font-size: 28px;
    font-weight: 400;
    letter-spacing: 2px;
    margin: 0;
    padding: 0;
    text-transform: uppercase;
}



#generic_price_table .generic_content,
#generic_price_table .generic_content:hover,
#generic_price_table .generic_content .generic_head_price .generic_head_content .head_bg,
#generic_price_table .generic_content:hover .generic_head_price .generic_head_content .head_bg,
#generic_price_table .generic_content .generic_head_price .generic_head_content .head h2,
#generic_price_table .generic_content:hover .generic_head_price .generic_head_content .head h2,
#generic_price_table .generic_content .price,
#generic_price_table .generic_content:hover .price,
#generic_price_table .generic_content .generic_price_btn a,
#generic_price_table .generic_content:hover .generic_price_btn a {
    transition: all 0.3s ease-in-out 0s;
    -moz-transition: all 0.3s ease-in-out 0s;
    -ms-transition: all 0.3s ease-in-out 0s;
    -o-transition: all 0.3s ease-in-out 0s;
    -webkit-transition: all 0.3s ease-in-out 0s;
}

@media (max-width: 320px) {}

@media (max-width: 767px) {
    #generic_price_table .generic_content {
        margin-bottom: 75px;
    }
}

@media (min-width: 768px) and (max-width: 991px) {
    #generic_price_table .col-md-3 {
        float: left;
        width: 50%;
    }

    #generic_price_table .col-md-4 {
        float: left;
        width: 50%;
    }

    #generic_price_table .generic_content {
        margin-bottom: 75px;
    }
}

@media (min-width: 992px) and (max-width: 1199px) {}

@media (min-width: 1200px) {}

#generic_price_table_home {
    font-family: 'Raleway', sans-serif;
}

.text-center h1,
.text-center h1 a {
    color: #7885CB;
    font-size: 30px;
    font-weight: 300;
    text-decoration: none;
}

.demo-pic {
    margin: 0 auto;
}

.demo-pic:hover {
    opacity: 0.7;
}


#generic_price_table_home .blue:hover,
#generic_price_table_home .emerald:hover,
#generic_price_table_home .grey:hover,
#generic_price_table_home .midnight:hover,
#generic_price_table_home .orange:hover,
#generic_price_table_home .purple:hover,
#generic_price_table_home .red:hover,
#generic_price_table_home .turquoise:hover {
    border-bottom-left-radius: 50px;
    border-bottom-right-radius: 50px;
    border-top-left-radius: 50px;
    border-top-right-radius: 50px;
    transition: all 0.3s ease-in-out 0s;
}
</style>